import { render, staticRenderFns } from "./my-account.vue?vue&type=template&id=153b1b28"
import script from "./my-account.vue?vue&type=script&lang=ts"
export * from "./my-account.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports